






























import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'; // デコレータ
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { Constants } from '../fixed/Constants';

/**
 * TemporarySave　一時保存機能
 *     画面入力内容を一時保存（JSONファイルとしてローカルにダウンロード）し、
 *     保存された入力内容（JSONファイル）からデータを読み取るコンポーネント。
 * @param value 呼び出し元の画面のformData(入力内容)の値
 * @return 読み取ったファイルの内容を返却（JSON型）
 */
@Component
export default class TemporarySave extends Vue {
  private isUploading: boolean = false;

  @Prop() private value: any;
  private tempValue: JSON = JSON.parse('{}');

  /**
   * 入力内容一時保存
   */
  // private temporarySaving() {
  //   //ie x
  //   if (window.confirm(Message.I0005)) {
  //     const a = document.createElement('a');
  //     a.href = URL.createObjectURL(
  //       new Blob([JSON.stringify(this.value)], { type: 'application/json' }),
  //     );
  //     a.download = Constants.ORG_FILE;
  //     a.style.display = 'none';
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //     alert(Message.I0006);
  //   } else {
  //     alert(Message.I0007);
  //   }
  // }
  private temporarySaving() {
    const blob = new Blob([JSON.stringify(this.value)], { type: 'application/json' });
    const name = '一時保存.json';

    const userAgent = window.navigator.userAgent.toLocaleLowerCase();
    if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
      // ie専用の処理
      window.navigator.msSaveBlob(blob, name);
    } else {
      const objectURL = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      const e = document.createEvent('MouseEvent');
      a.href = objectURL;
      a.setAttribute('download', name || 'noname');
      e.initEvent('click', true, true);
      a.dispatchEvent(e);
    }
  }

  /**
   * 読込ボタンクリック
   */
  private btnclick() {
    // this.$refs.input.click();
    (this.$refs.input as Vue & { click: () => boolean }).click();
  }
  /**
   * ファイル読み込み処理（同期型）
   */
  private readFile(reader: FileReader) {
    return new Promise(
      (resolve: (value: any) => void, reject: (reason?: any) => void) => {
        reader.onload = (event) => {
          try {
            JSON.parse(JSON.stringify(reader.result));
          } catch (error) {
            // 処理失敗
            reject(error);
          }
          // 処理成功
          resolve(reader.result);
        };
      },
    );
  }

  /**
   * ファイル選択後の処理
   */
  private async selectedFile() {
    this.isUploading = true;
    const files: FileList | null = (this.$refs.input as HTMLInputElement).files;
    const file = files !== null ? files[0] : null;
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.readAsText(file);
    await this.readFile(reader)
      .then((value: string) => {
        this.tempValue = JSON.parse(value);
        // alert(Message.I0008);
        this.returnValue();
      })
      .catch((reason: any) => {
        alert(Message.E0009);
      });
  }
  @Emit('tempValue')
  private returnValue() {
    return this.tempValue;
  }
}
